/* The (old) AddressFormContainer with separate entry for each field */
import type { ComponentProps } from 'react';

import type { ApiAddressWithFormData } from '#/api/types/ApiAddress';
import { FormContextConsumer } from '#/components/Form/FormContext';

import { AddressFormSeparateContainerInternal } from './AddressFormSeparateContainerInternal';

type AddressFormSeparateContainerProps = Omit<
  ComponentProps<typeof AddressFormSeparateContainerInternal>,
  | 'address'
  | 'clearErrors'
  | 'error'
  | 'errors'
  | 'namePrefix'
  | 'setFetchingAddress'
  | 'updateAddress'
>;

export function AddressFormSeparateContainer({
  index,
  ...restProps
}: AddressFormSeparateContainerProps) {
  const addressKey = index !== undefined ? `addresses.${index}` : 'address';
  return (
    <FormContextConsumer>
      {({
        clearErrors,
        updateValueWith,
        setFetchingAddress,
        errors,
        getValue,
      }) => (
        <AddressFormSeparateContainerInternal
          index={index}
          address={
            getValue(addressKey) as ApiAddressWithFormData | null | undefined
          }
          namePrefix={addressKey}
          setFetchingAddress={setFetchingAddress}
          updateAddress={(update) => {
            updateValueWith(addressKey, (a: Record<string, unknown>) => ({
              ...a,
              ...update,
            }));
          }}
          clearErrors={clearErrors}
          error={errors[addressKey]}
          errors={errors}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...restProps}
        />
      )}
    </FormContextConsumer>
  );
}
